module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "has-text-centered white"
  }, [_c('p', [_vm._v("Diseñado por"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Ignacio")])]), _c('p', [_c('a', {
    staticClass: "icon",
    attrs: {
      "href": "https://github.com/mrignacio1231"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-082d5cb7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/views/Footer.pug
// module id = 17
// module chunks = 0